
<span :class="$style.root">
  <slot></slot>
</span>
